import * as React from "react";

import { Block } from "kanopi-components/Block";
import { Card, CardBody } from "kanopi-components/Card";
import { Img } from "kanopi-components/Image";
import { HeadingMedium } from "kanopi-components/typography";
import { useUnderBreakpoint } from "kanopi-components/useUnderBreakpoint";

type TProps = {
  inactiveSectionRef: React.RefObject<HTMLDivElement>;
};

const AddCoverTile: React.FC<TProps> = ({ inactiveSectionRef }) => {
  const isMobile = useUnderBreakpoint("medium");
  const goToInactiveCovers = () => {
    inactiveSectionRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  return inactiveSectionRef ? (
    <>
      <Block display="flex" flex={1} flexDirection="column">
        <Card
          borderWidth={"0px"}
          display="flex"
          flexDirection="column"
          flex="1"
          marginBottom={[0, 0, 0, "54px"]}
          overrides={{
            Block: {
              style: {
                opacity: 0.5,
                ":hover": {
                  cursor: "pointer",
                },
              },
              props: {
                onClick: goToInactiveCovers,
              },
            },
          }}
        >
          <CardBody display="flex" flex={1}>
            <Block
              display="flex"
              flex={1}
              flexDirection={isMobile ? "row" : "column"}
              alignItems="center"
              justifyContent="center"
            >
              <Img src="icons/plus-large.svg" fluid />
              <HeadingMedium
                overrides={{ Block: { style: { opacity: 0.5 } } }}
                marginLeft={isMobile ? "scale500" : 0}
              >
                Add a cover
              </HeadingMedium>
            </Block>
          </CardBody>
        </Card>
      </Block>
    </>
  ) : null;
};

export { AddCoverTile };
